import axios, { AxiosError } from 'axios'
import { UserInvitation } from 'components/UserInvitationModal/types'
import config from 'config'

export default async function inviteNewUser(values: UserInvitation) {
    try {
        const { data } = await axios.post(
            `${config.API_BASE_URL}/api/v3/user_invitation/`,
            {
                email: values.emailAddress,
                first_name: values.firstName,
                last_name: values.lastName,
                level_of_access: values.levelOfAccess,
                application_access: values.applicationAccess,
            },
            {
                withCredentials: true,
            },
        )

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        throw axiosError
    }
}
